module.exports = __webpack_public_path__ + "static/banner-phones-mobile-f1f7baecd5307a53bd8b3e5717839ced.png";